import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function ({
  className,
  color,
  size,
  style,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ')}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 20 11"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 1.26394L19.1463 10.8465C19.3415 11.051 19.6581 11.0512 19.8534 10.8469C20.0487 10.6425 20.0489 10.3111 19.8537 10.1066L10.3537 0.153459C10.1584 -0.051154 9.84159 -0.0511541 9.6463 0.153459L0.146298 10.1066C-0.0488834 10.3111 -0.0487499 10.6425 0.146595 10.8469C0.34194 11.0512 0.658522 11.051 0.853703 10.8465L10 1.26394Z"
      />
    </svg>
  );
}
